import { isContractCancelled } from "./isContractCancelled.js";
export const isAlreadySubscribed = (subscriptionVariantsSkus, existingContracts) => {
    const matchingContract = existingContracts.find((contract) => contract.item.sku &&
        subscriptionVariantsSkus.includes(contract.item.sku) &&
        !isContractCancelled(contract.status.renewAt));
    if (matchingContract) {
        return true;
    }
    return false;
};
